<template>

    <!-- Modal -->
    <div class="modal fade" id="primaryModal" tabindex="-1" aria-labelledby="primaryModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="primaryModalLabel">{{ title }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <slot />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">abbrechen</button>
                    <button type="button" class="btn btn-primary">OK</button>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
    export default {
        props: {
            title: {
                type: String,
                default: 'Marktplatz',
            }
        },
        data() {
            return {

            }
        }
    }
</script>